import { render } from "./vcouponadd.vue?vue&type=template&id=c4dbd320&scoped=true"
import script from "./vcouponadd.vue?vue&type=script&lang=js"
export * from "./vcouponadd.vue?vue&type=script&lang=js"

import "./vcouponadd.vue?vue&type=style&index=0&id=c4dbd320&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4dbd320"]])

export default __exports__